import styled from "styled-components";

const HomeSlogan = styled.h1`
  text-align: center;
  color: #ffffff;
  font-size: 48px;
  max-width: 1200px;
  font-style: italic;
  font-family: "PT Serif", serif;
  line-height: 1.6;
  margin-top: 48px;
  margin-bottom: 20px;
`

export default HomeSlogan